import React from 'react';
import { MessageOutlined } from '@ant-design/icons';
import { useAppLayout } from '../AppShell/AppLayoutContext';
import { IconButton } from '../UI/nav/IconButton';
import headerStyles from '../UI/nav/AppHeader.module.css';

export const HeaderChatPanelShortcut: React.FC = () => {
  const { chatPanelExpanded, expandChatPanel } = useAppLayout();

  return (
    <IconButton
      label={chatPanelExpanded ? 'Chat panel open' : 'Open chat panel'}
      aria-pressed={chatPanelExpanded}
      className={chatPanelExpanded ? headerStyles.iconBtnActive : undefined}
      onClick={expandChatPanel}
      data-testid="header-chat-panel-shortcut"
    >
      <MessageOutlined />
    </IconButton>
  );
};
